export default {
    "auto": true,
    "background": "#000319",
    "bgMusic": "",
    "changeMode": 1,
    "colorOrImg": "2",
    "height": 1080,
    "name": "1",
    "page": [
        {
            "element": [
                {
                    "animation": {
                        "group": [
                            {
                                "ani": [
                                ],
                                "name": "enter",
                                "start": {
                                },
                                "title": "进入"
                            },
                            {
                                "ani": [
                                ],
                                "name": "loop",
                                "repeat": 0,
                                "repeatDelay": 0,
                                "title": "循环",
                                "yoyo": false
                            },
                            {
                                "ani": [
                                ],
                                "name": "exit",
                                "title": "退出"
                            }],
                        "title": "动画"
                    },
                    "class": "ky.element.KYParticle",
                    "fun": {
                    },
                    "styles": {
                        "group": [
                            {
                                "particleData": {
                                    "acceleration": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "addAtBack": false,
                                    "alpha": {
                                        "end": 0,
                                        "start": 0.5
                                    },
                                    "blendMode": "normal",
                                    "color": {
                                        "end": "#3fcbff",
                                        "start": "#e4f9ff"
                                    },
                                    "emitterLifetime": -1,
                                    "frequency": 0.001,
                                    "lifetime": {
                                        "max": 5,
                                        "min": 0.2
                                    },
                                    "maxParticles": 100,
                                    "maxSpeed": 0,
                                    "noRotation": false,
                                    "rotationSpeed": {
                                        "max": 0,
                                        "min": 0
                                    },
                                    "scale": {
                                        "end": 0.01,
                                        "minimumScaleMultiplier": 1,
                                        "start": 0.5
                                    },
                                    "spawnCircle": {
                                        "r": 0,
                                        "x": 0,
                                        "y": 0
                                    },
                                    "spawnRect": {
                                        "h": 0,
                                        "w": 0,
                                        "x": 0,
                                        "y": 0
                                    },
                                    "spawnType": "circle",
                                    "speed": {
                                        "end": 50,
                                        "minimumSpeedMultiplier": 1,
                                        "start": 200
                                    },
                                    "startRotation": {
                                        "max": 360,
                                        "min": 0
                                    },
                                    "textureName": "https://h5.ledfin.cn/static/iisSpace/runtime/res/texture.png",
                                    "pos": {
                                        "x": 0,
                                        "y": 0
                                    }
                                },
                                "title": "数据"
                            },
                            {
                                "title": "尺寸与位置",
                                "x": 300,
                                "y": 300
                            }],
                        "name": "粒子名",
                        "title": "属性"
                    },
                    "type": "KYParticle",
                    "uuid": "fd1125ab-9cb2-4b48-9322-518d9a7e590a"
                }],
            "name": "1",
            "uuid": "291b-1591340794728-08171"
        }],
    "pageHoldTime": 10,
    "time": "09:00-12:00",
    "topPage": {
        "element": [],
        "name": "置顶层",
        "uuid": "6ca667e9-49cb-40eb-8327-f2e4560ab4f6"
    },
    "width": 1920
}